import { useState } from "react";

import { buildContractFromTemplate } from "@/lib/contractIntelligence/buildContractFromTemplate";
import type { ContractIntelligenceContract } from "@/types/contractIntelligence.types";
import type { ContractTemplate, ContractTemplateAnswers } from "@/types/contractIntelligence.types";

import { ContractTemplateChatForm } from "./ContractTemplateChatForm";
import { ContractTemplatePicker } from "./ContractTemplatePicker";
import { ContractTemplateReview } from "./ContractTemplateReview";

interface ContractTemplateGeneratorProps {
  onCancel: () => void;
  onUploadExisting: () => void;
  onComplete: (contract: ContractIntelligenceContract) => void;
}

export function ContractTemplateGenerator({
  onCancel,
  onUploadExisting,
  onComplete,
}: ContractTemplateGeneratorProps) {
  const [template, setTemplate] = useState<ContractTemplate | null>(null);
  const [answers, setAnswers] = useState<ContractTemplateAnswers | null>(null);

  if (!template) {
    return (
      <ContractTemplatePicker
        onPick={setTemplate}
        onCancel={onCancel}
        onUploadExisting={onUploadExisting}
      />
    );
  }

  if (!answers) {
    return (
      <ContractTemplateChatForm
        template={template}
        onBack={() => setTemplate(null)}
        onComplete={setAnswers}
      />
    );
  }

  return (
    <ContractTemplateReview
      template={template}
      answers={answers}
      onBack={() => setAnswers(null)}
      onCreate={() => onComplete(buildContractFromTemplate(template, answers))}
    />
  );
}
